import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getProgramById } from "@/shared/apiHelper";
import ProgramBreadcrumb from "@/shared/components/ProgramBreadcrumb";
import SelectProgram from "./components/SelectProgram";
import { Col, Container, Row, Card, CardBody } from "reactstrap";
import Import from "./components/Import";
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const SectionLabel = ({ title, tooltip }) => (
  <div className="d-flex align-items-center mb-1">
    <h5 className="mb-0">{title}</h5>
    {tooltip && (
      <Tooltip title={tooltip} arrow placement="right">
        <IconButton size="small" style={{ padding: 4, marginLeft: 6 }}>
          <InfoOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    )}
  </div>
);

const CsvImport = ({ organization, program }) => {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={9}>
          <h3 className="page-title">CSV Import</h3>
          <h3 className="page-subhead subhead">
            <Link to="/">Home</Link> /{" "}
            <Link to="/program">Programs</Link>
            <ProgramBreadcrumb program={program} linkSelf={true} /> / CSV Import
          </h3>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <Card>
            <CardBody style={{ padding: "2rem" }}>
            <Row className="mb-3">
                <Col md={12} className="d-flex justify-content-end">
                    <Link
                    className="btn btn-success account__btn account__btn--small w-auto"
                    to={`/program/${program.id}/import-list`}
                    >
                    Import History
                    </Link>
                </Col>
            </Row>
              {/* Program Section */}
              <Row className="mb-4">
                <Col md={8} lg={6}>
                  <SectionLabel
                    title="Program"
                    tooltip="Choose the program where users and data will be imported."
                  />
                  <small className="text-muted d-block mb-2">
                    Select the program you want to import to
                  </small>
                  <SelectProgram label="" rootProgram={program} />
                </Col>
              </Row>

              {/* Divider */}
              <hr className="my-4" />

              {/* CSV Import Type + File Upload Section */}
              <Row>
                <Col md={12}>
                  <Import
                    passedProgram={program}
                    passedOrganization={organization}
                  />
                </Col>
              </Row>

            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

const Wrapper = ({ organization, theme, rtl }) => {
  const { programId } = useParams();
  const [programData, setProgramData] = useState(null);

  useEffect(() => {
    if (organization && programId) {
      getProgramById(organization.id, programId, { hierarchy: true }).then(
        (p) => setProgramData(p)
      );
    }
  }, [organization, programId]);

  if (!organization || !programData) return "Loading...";

  return (
    <CsvImport
      organization={organization}
      program={programData}
      theme={theme}
      rtl={rtl}
    />
  );
};

export default withRouter(
  connect((state) => ({
    theme: state.theme,
    rtl: state.rtl,
    organization: state.organization,
  }))(Wrapper)
);